export const UserStatus = {
  active: {
    title: "Active",
    value: "active",
  },
  inactive: {
    title: "Inactive",
    value: "inactive",
  },
  invited: {
    title: "Invited",
    value: "invited",
  },
};
